declare namespace $ {

	type $mol_string__value_shm_hitalama_domain_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['baza_url'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_check_box__title_shm_hitalama_domain_page_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_domain_page_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['online'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_domain_page_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_domain_page_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['online_agent'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__click_shm_hitalama_domain_page_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['domain_grab'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_string__value_shm_hitalama_domain_page_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['domain_link'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_view__sub_shm_hitalama_domain_page_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_domain_page_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['profiles_grab'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_domain_page_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_domain_page_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['templates_js_reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_domain_page_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_domain_page_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['templates_tsx_reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_domain_page_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_domain_page_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['templates_sql_reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_domain_page_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_domain_page_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['templates_commands_reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_text__text_shm_hitalama_domain_page_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['profiles_link'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_domain_page_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_textarea__value_shm_hitalama_domain_page_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['profile_keys'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_link__arg_shm_hitalama_domain_page_21 = $mol_type_enforce<
		({ 
			'section': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_text__text_shm_hitalama_domain_page_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['current_map_link'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_domain_page_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_domain_page_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_domain_page_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_domain_page_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['current_map_reupdate'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_domain_page_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__value_shm_hitalama_domain_page_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['overlayed_map_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_check_box__title_shm_hitalama_domain_page_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_domain_page_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['overlayed_map_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_shm_hitalama_domain_page_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_domain_page_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['running_fiber_visible'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_page__body_shm_hitalama_domain_page_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_hitalama_map_book_widgets3__map_shm_hitalama_domain_page_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['current_map'] >
		,
		ReturnType< $shm_hitalama_map_book_widgets3['map'] >
	>
	type $shm_hitalama_map_book_widgets3__Map_page_shm_hitalama_domain_page_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_domain_page['Current_map_widgets3_map_page'] >
		,
		ReturnType< $shm_hitalama_map_book_widgets3['Map_page'] >
	>
	export class $shm_hitalama_domain_page extends $mol_book2 {
		Status( ): $giper_baza_status
		baza_url( next?: string ): string
		Baza_url( ): $mol_string
		online( next?: boolean ): boolean
		Online( ): $mol_check_box
		online_agent( next?: boolean ): boolean
		Online_agent( ): $mol_check_box
		domain_grab( next?: any ): any
		Domain_grab( ): $mol_button_minor
		domain_link( next?: string ): string
		Domain_link( ): $mol_string
		domain_can_change( ): string
		Domain_can_change( ): $mol_view
		profiles_grab( next?: any ): any
		Profiles_grab( ): $mol_button_minor
		templates_js_reset( next?: any ): any
		Templates_js_reset( ): $mol_button_minor
		templates_tsx_reset( next?: any ): any
		Templates_tsx_reset( ): $mol_button_minor
		templates_sql_reset( next?: any ): any
		Templates_sql_reset( ): $mol_button_minor
		templates_commands_reset( next?: any ): any
		Templates_commands_reset( ): $mol_button_minor
		profiles_link( ): string
		Profiles_link( ): $mol_text
		profiles_can_change( ): string
		Profiles_can_change( ): $mol_view
		profile_keys( ): string
		Profiles( ): $mol_textarea
		Hidden_reg( ): $mol_link
		current_map_link( ): string
		Current_map_link( ): $mol_text
		current_map_version( ): string
		Current_map_version( ): $mol_view
		current_map_latest_version( ): string
		Current_map_latest_version( ): $mol_view
		current_map_reupdate( next?: any ): any
		Current_map_reupdate( ): $mol_button_minor
		Current_map_section( ): $mol_view
		overlayed_map_id( next?: string ): string
		Overlayed_map_id( ): $mol_string
		overlayed_map_enabled( next?: boolean ): boolean
		Overlayed_map_enabled( ): $mol_check_box
		running_fiber_visible( next?: boolean ): boolean
		Running_fiber_visible( ): $mol_check_box
		Settings( ): $mol_page
		current_map( ): $shm_hitalama_map
		Current_map_widgets3_map_page( ): $shm_hitalama_map_page
		Current_map_widgets3( ): $shm_hitalama_map_book_widgets3
		Current_map_widgets3_visible( ): readonly(any)[]
		tools( ): readonly(any)[]
		placeholders( ): readonly(any)[]
		pages( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map